<template>
    <div>
        <div
          v-if="isMobile"
          class="d-flex justify-content-between align-items-center mb-2 py-2 px-3"
        >
          <b-button
            size="sm"
            variant="outline-primary"
            @click="filtersVisible = !filtersVisible"
          >
            <b-icon-funnel-fill class="mr-1" />
            {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
          </b-button>
        </div>

        <div class="d-flex flex-column flex-lg-row" style="gap: 7px; width: 100%;">

          <b-alert
            variant="secondary"
            show
            style="display: flex; gap: 7px; width: 100%;"
            :style="{'max-width': isMobile ? 'none' : '320px'}"
          >
            <div style="display: inline-block; vertical-align: top;">
              <div>DATES</div>

              <date-picker
                v-model="date_range"
                format="MM-DD-YYYY"
                valueType="format"
                style="width: 100%; font-size: 15px; display: block;"
                :style="{'max-width': isMobile ? 'none' : '300px'}"
                placeholder="DATE OR DATE RANGE"
                range
              ></date-picker>
            </div>

            <div style="display: inline-block; vertical-align: top;">
              <div>&nbsp;</div>
              <b-button
                variant="success"
                style="display: inline-block; padding: 4px;"
                @click="fetchFinanceData"
              >
                SEARCH
              </b-button>
            </div>
          </b-alert>

          <b-collapse :visible="!isMobile || filtersVisible" style="width: 100%;" v-if="financeData.length > 0">
            <b-alert variant="secondary" show style="display: inline-block; vertical-align: top;">

              <div
                style="display: inline-block; vertical-align: top;"
                v-if="packet.userDetails.userrole == 'admin' && financeData.length > 0"
              >
                <div>SALE LOCATION</div>
                <b-form-select
                  :options="available_locations"
                  v-model="picked_location"
                  style="width: 100%;"
                  :style="{'max-width': isMobile ? 'none' : '200px'}"
                  @change="locationChanged"
                ></b-form-select>
              </div>

              <div
                style="display: inline-block; vertical-align: top;"
                v-if="(packet.userDetails.userrole == 'admin' || packet.userDetails.userrole == 'locationadmin') && financeData.length > 0"
              >
                <div>SALESPERSON</div>
                <b-form-select
                  :options="available_salespeople"
                  v-model="picked_user"
                  style="width: 100%;"
                  :style="{'max-width': isMobile ? 'none' : '200px'}"
                  @change="processFinanceData"
                ></b-form-select>
              </div>

              <div style="display: inline-block; vertical-align: top;" v-if="financeData.length > 0">
                <div>FINANCE COMPANY</div>
                <b-form-select
                  :options="finance_company_options"
                  v-model="picked_finance_company"
                  style="width: 100%;"
                  :style="{'max-width': isMobile ? 'none' : '200px'}"
                  @change="processFinanceData"
                ></b-form-select>
              </div>

              <div style="display: inline-block; vertical-align: top;" v-if="financeData.length > 0">
                <div>VIEW TYPE</div>
                <b-form-select
                  :options="view_type_options"
                  v-model="view_type"
                  style="width: 100%;"
                  :style="{'max-width': isMobile ? 'none' : '200px'}"
                  @change="processFinanceData"
                ></b-form-select>
              </div>

              <div
                style="display: inline-block; vertical-align: top; margin-left: 15px;"
                v-if="financeData.length > 0"
              >
                <div>&nbsp;</div>
                <b-form-checkbox
                  v-model="autoRefreshEnabled"
                  @change="toggleAutoRefresh"
                  switch
                >
                  Auto Refresh (30s)
                </b-form-checkbox>
              </div>

            </b-alert>
          </b-collapse>
        </div>

            <b-card-text style="gap: 5px;" class="d-flex flex-wrap ml-3">
                <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='today'" @click="set_dates('today')">Today</b-button>
                <b-button size="sm" variant="outline-danger"  :pressed="picked_date_range=='yesterday'" @click="set_dates('yesterday')">Yesterday</b-button>
                <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='this_week'" @click="set_dates('this_week')">This Week</b-button>
                <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='last_week'" @click="set_dates('last_week')">Last Week</b-button>
                <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='this_month'" @click="set_dates('this_month')">This Month</b-button>
                <b-button size="sm" variant="outline-danger"  :pressed="picked_date_range=='last_month'" @click="set_dates('last_month')">Last Month</b-button>

                <!-- Export Buttons -->
                <b-button size="sm" variant="outline-primary" style="margin-left: 10px;" @click="exportAllFinanceData" v-if="financeData.length > 0">
                    <i class="fas fa-download"></i> Export All Data
                </b-button>
                <b-button size="sm" variant="outline-info" @click="exportSummaryData" v-if="financeData.length > 0 && view_type === 'summary'">
                    <i class="fas fa-file-export"></i> Export Summary
                </b-button>
            </b-card-text>

            <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">

                <!-- KPI Summary Row -->
                <div v-if="financeData.length > 0" class="finance-kpi-row">
                    <div class="kpi-item">
                        <div class="kpi-value">${{ formatNumber(summaryTotals.approvedAmount) }}</div>
                        <div class="kpi-label">Total Approved</div>
                    </div>
                    <div class="kpi-item">
                        <div class="kpi-value">{{ getUtilizationPercentage() }}%</div>
                        <div class="kpi-label">Utilization Rate</div>
                    </div>
                    <div class="kpi-item">
                        <div class="kpi-value">{{ financeCompaniesCount }}</div>
                        <div class="kpi-label">Finance Companies</div>
                    </div>
                    <div class="kpi-item">
                        <div class="kpi-value">{{ summaryTotals.totalInvoices }}</div>
                        <div class="kpi-label">Total Invoices</div>
                    </div>
                    <div class="kpi-item">
                        <div class="kpi-value" :class="getBalanceClass(summaryTotals.balanceAmount)">
                            ${{ formatNumber(summaryTotals.balanceAmount) }}
                        </div>
                        <div class="kpi-label">Available Balance</div>
                    </div>
                </div>

                <!-- FINANCE COMPANIES CARDS GRID -->
                <div v-if="financeData.length > 0 && showFinanceCompaniesGrid" class="finance-companies-cards-section">
                    <div class="section-header">
                        <h5 class="section-title">
                            <i class="fas fa-university"></i>
                            Finance Companies Overview
                        </h5>
                        <div class="section-actions">
                            <b-form-input
                                v-model="companySearch"
                                placeholder="Search companies..."
                                size="sm"
                                style="width: 200px;"
                            ></b-form-input>
                            <b-button size="sm" variant="outline-primary" @click="toggleFinanceCompaniesGrid">
                                <i class="fas fa-times"></i> Hide
                            </b-button>
                        </div>
                    </div>

                    <div class="finance-companies-grid">
                        <div v-for="company in filteredFinanceCompanies" :key="company.name"
                            class="finance-company-full-card clickable-card"
                            @click="filterByFinanceCompany(company.name)">
                            <div class="company-full-card-header">
                                <div class="company-avatar-large">
                                    {{ getCompanyInitials(company.name) }}
                                </div>
                                <div class="company-main-info">
                                    <h6 class="company-full-name">{{ company.name }}</h6>
                                    <div class="company-meta">
                                        <span class="meta-item">
                                            <i class="fas fa-file-invoice"></i>
                                            {{ company.invoiceCount }} Invoices
                                        </span>
                                        <span class="meta-item">
                                            <i class="fas fa-chart-pie"></i>
                                            {{ company.utilizationRate.toFixed(1) }}% Used
                                        </span>
                                    </div>
                                </div>
                                <div class="company-status" :class="getCompanyStatusClass(company.utilizationRate)">
                                    {{ getCompanyStatus(company.utilizationRate) }}
                                </div>
                            </div>

                            <div class="company-full-card-body">
                                <div class="company-stats-grid">
                                    <div class="company-stat">
                                        <div class="stat-label">Approved Amount</div>
                                        <div class="stat-value">${{ formatNumber(company.approvedAmount) }}</div>
                                        <div class="stat-trend">
                                            <i class="fas fa-arrow-up" v-if="company.approvedAmount > 0"></i>
                                            Total Credit
                                        </div>
                                    </div>

                                    <div class="company-stat">
                                        <div class="stat-label">Used Amount</div>
                                        <div class="stat-value">${{ formatNumber(company.usedAmount) }}</div>
                                        <div class="stat-trend">
                                            <i class="fas fa-chart-line"></i>
                                            {{ ((company.usedAmount / company.approvedAmount) * 100).toFixed(1) }}% of Limit
                                        </div>
                                    </div>

                                    <div class="company-stat">
                                        <div class="stat-label">Balance</div>
                                        <div class="stat-value" :class="getBalanceClass(company.balanceAmount)">
                                            ${{ formatNumber(company.balanceAmount) }}
                                        </div>
                                        <div class="stat-trend">
                                            <i class="fas fa-wallet"></i>
                                            Available
                                        </div>
                                    </div>
                                </div>

                                <div class="company-progress-section">
                                    <div class="progress-header">
                                        <span>Credit Utilization</span>
                                        <span>{{ company.utilizationRate.toFixed(1) }}%</span>
                                    </div>
                                    <div class="progress-bar-full">
                                        <div class="progress-track">
                                            <div class="progress-fill" :style="{ width: company.utilizationRate + '%' }"
                                                 :class="getProgressColorClass(company.utilizationRate)"></div>
                                        </div>
                                        <div class="progress-labels">
                                            <span>0%</span>
                                            <span>50%</span>
                                            <span>100%</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="company-performance">
                                    <div class="performance-item">
                                        <div class="performance-label">Avg. per Invoice</div>
                                        <div class="performance-value">
                                            ${{ formatNumber(company.approvedAmount / company.invoiceCount) }}
                                        </div>
                                    </div>
                                    <div class="performance-item">
                                        <div class="performance-label">Efficiency</div>
                                        <div class="performance-value" :class="getEfficiencyClass(company.utilizationRate)">
                                            {{ getEfficiencyRating(company.utilizationRate) }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="company-full-card-footer">
                                <div class="click-hint">
                                    <i class="fas fa-mouse-pointer"></i>
                                    Click to view details for {{ company.name }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="filteredFinanceCompanies.length === 0" class="no-companies-found">
                        <i class="fas fa-search"></i>
                        <h5>No finance companies found</h5>
                        <p>Try adjusting your search criteria</p>
                    </div>
                </div>

                <!-- Show Finance Companies Grid Button -->
                <div v-if="financeData.length > 0 && !showFinanceCompaniesGrid" class="show-companies-section">
                    <b-button variant="outline-primary" size="lg" @click="toggleFinanceCompaniesGrid" class="show-companies-btn">
                        <i class="fas fa-building"></i>
                        Show Finance Companies Overview
                    </b-button>
                </div>

                <!-- DETAILED VIEW -->
                <div v-if="financeData.length > 0 && view_type === 'detailed'" style="margin-top: 10px; overflow: scroll;" class="mx-2 mb-2">
                    <table class="text-monospace" style="width: 100%;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <th class="ipt_tdhr" @click="sortby('ts')" style="width: 170px;">
                                    DATE
                                </th>
                                <th class="ipt_tdhr" @click="sortby('locsub')">
                                    STORE LOCATION
                                </th>
                                <th class="ipt_tdhr" @click="sortby('finance_company')">
                                    FINANCE COMPANY
                                </th>
                                <th class="ipt_tdhr" @click="sortby('username')">
                                    SALES PERSON
                                </th>
                                <th class="ipt_tdhr" @click="sortby('invoice_id')">
                                    INVOICE #
                                </th>
                                <th class="ipt_tdhr" @click="sortby('approved_amount')">
                                    APPROVED AMOUNT
                                </th>
                                <th class="ipt_tdhr" @click="sortby('used_amount')">
                                    USED AMOUNT
                                </th>
                                <th class="ipt_tdhr" @click="sortby('balance_amount')">
                                    BALANCE AMOUNT
                                </th>
                                <th class="ipt_tdhr" @click="sortby('total_dollar_amount')">
                                    TOTAL SOLD
                                </th>
                                <th class="ipt_tdhr">
                                    DIFF
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr style="background: lightyellow;">
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header">
                                    <b>TOTALS</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ total('approved_amount').toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ total('used_amount').toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ total('balance_amount').toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ total('total_dollar_amount').toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ (total('total_dollar_amount') - total('total_actualized_dollar_amount')).toFixed(2) }}</b>
                                </td>
                            </tr>
                        </tbody>

                        <tbody>
                            <tr v-for="item,idx in filteredFinanceData" v-bind:key="idx" :style="getFinanceRowStyle(item)">
                                <td class="ipt_tdhr non-header">
                                    {{ formatDate(item.ts) }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ getLocationName(item.locsub) }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ getFinanceCompanyName(item) }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.username }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.invoice_id }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ (item.finance_approved_amount || item.approved_amount || 0.0).toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ (item.finance_used_amount || getUsedAmount(item) || 0.0).toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr non-header" :style="getBalanceStyle(item)">
                                    {{ (item.finance_balance_amount || getBalanceAmount(item) || 0.0).toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ (item.total_dollar_amount || 0.0).toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ (item.total_dollar_amount - item.total_actualized_dollar_amount || 0.0).toFixed(2) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- SUMMARY VIEW -->
                <div v-if="financeData.length > 0 && view_type === 'summary'" style="margin-top: 10px; overflow: scroll;">
                    <table class="text-monospace" style="width: 100%;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <td class="ipt_tdhr" @click="sortSummary('location')">
                                    LOCATION
                                </td>
                                 <td class="ipt_tdhr" @click="sortSummary('salesperson')">
                                    SALESPERSON
                                </td>
                                <td class="ipt_tdhr" @click="sortSummary('financeCompany')">
                                    FINANCE COMPANY
                                </td>
                                <td class="ipt_tdhr" @click="sortSummary('totalInvoices')">
                                    TOTAL INVOICES
                                </td>
                                <td class="ipt_tdhr" @click="sortSummary('approvedAmount')">
                                    APPROVED AMOUNT
                                </td>
                                <td class="ipt_tdhr" @click="sortSummary('usedAmount')">
                                    USED AMOUNT
                                </td>
                                <td class="ipt_tdhr" @click="sortSummary('balanceAmount')">
                                    BALANCE AMOUNT
                                </td>
                                <td class="ipt_tdhr" @click="sortSummary('totalSales')">
                                    TOTAL SALES
                                </td>
                                <td class="ipt_tdhr" @click="sortSummary('averageApproved')">
                                    AVG APPROVED
                                </td>
                                <td class="ipt_tdhr" @click="sortSummary('utilizationRate')">
                                    UTILIZATION %
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr style="background: lightyellow;">
                                <td class="ipt_tdhr header">
                                    <b>GRAND TOTALS</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>-</b>
                                </td>
                                  <td class="ipt_tdhr header">
                                    <b>-</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ summaryTotals.totalInvoices }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ summaryTotals.approvedAmount.toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ summaryTotals.usedAmount.toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header" :style="getSummaryBalanceStyle(summaryTotals.balanceAmount)">
                                    <b>{{ summaryTotals.balanceAmount.toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ summaryTotals.totalSales.toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ summaryTotals.averageApproved.toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ summaryTotals.utilizationRate.toFixed(1) }}%</b>
                                </td>
                            </tr>
                        </tbody>

                        <tbody>
                            <tr v-for="summary,idx in sortedSummaryData" v-bind:key="idx" :style="getSummaryRowStyle(summary)">
                                <td class="ipt_tdhr non-header">
                                    {{ summary.location }}
                                </td>
                                 <td class="ipt_tdhr non-header">
                                        {{ summary.salesperson || 'All' }}
                                    </td>
                                <td class="ipt_tdhr non-header">
                                    {{ summary.financeCompany }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ summary.totalInvoices }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ summary.approvedAmount.toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ summary.usedAmount.toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr non-header" :style="getSummaryBalanceStyle(summary.balanceAmount)">
                                    {{ summary.balanceAmount.toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ summary.totalSales.toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ summary.averageApproved.toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr non-header" :style="getUtilizationStyle(summary.utilizationRate)">
                                    {{ summary.utilizationRate.toFixed(1) }}%
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- LOCATION SUMMARY VIEW -->
                <div v-if="financeData.length > 0 && view_type === 'location_summary'" style="margin-top: 10px; overflow: scroll;">
                    <table class="text-monospace" style="width: 100%; border-collapse: collapse; min-width: 800px;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <th class="ipt_tdhr" rowspan="2" style="vertical-align: middle; min-width: 150px;">FINANCE COMPANY</th>
                                <th v-for="location in allLocations" :key="location" 
                                    class="ipt_tdhr" colspan="3" style="text-align: center;">
                                    {{ location }}
                                </th>
                                <th class="ipt_tdhr" colspan="3" style="text-align: center;">TOTAL</th>
                            </tr>
                            <tr style="background: #c3cdd3;">
                                <!-- Location sub-headers -->
                                <template v-for="location in allLocations">
                                    <th :key="location + '-sales-sub'" class="ipt_tdhr sub-header">SALES</th>
                                    <th :key="location + '-used-sub'" class="ipt_tdhr sub-header">USED</th>
                                    <th :key="location + '-approved-sub'" class="ipt_tdhr sub-header">APPROVED</th>
                                </template>
                                <!-- Total sub-headers -->
                                <th class="ipt_tdhr sub-header">SALES</th>
                                <th class="ipt_tdhr sub-header">USED</th>
                                <th class="ipt_tdhr sub-header">APPROVED</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="company in locationSummaryData" :key="company.financeCompany" style="background: white;">
                                <!-- Finance Company Name -->
                                <td class="ipt_tdhr non-header" style="font-weight: bold; text-align: left;">
                                    {{ company.financeCompany }}
                                </td>
                                
                                <!-- Location Data Columns -->
                                <template v-for="location in allLocations">
                                    <td :key="location + '-sales-' + company.financeCompany" class="ipt_tdhr non-header">
                                        {{ getLocationData(company, location).totalInvoices || 0 }}
                                    </td>
                                    <td :key="location + '-used-' + company.financeCompany" class="ipt_tdhr non-header">
                                        {{ formatNumber(getLocationData(company, location).usedAmount) }}
                                    </td>
                                    <td :key="location + '-approved-' + company.financeCompany" class="ipt_tdhr non-header">
                                        {{ formatNumber(getLocationData(company, location).approvedAmount) }}
                                    </td>
                                </template>
                                
                                <!-- Total Columns -->
                                <td class="ipt_tdhr non-header" style="font-weight: bold;">
                                    {{ company.totals.totalInvoices }}
                                </td>
                                <td class="ipt_tdhr non-header" style="font-weight: bold;">
                                    {{ formatNumber(company.totals.usedAmount) }}
                                </td>
                                <td class="ipt_tdhr non-header" style="font-weight: bold;">
                                    {{ formatNumber(company.totals.approvedAmount) }}
                                </td>
                            </tr>
                        </tbody>

                        <!-- Grand Totals Row -->
                        <tfoot>
                            <tr style="background: lightyellow;">
                                <td class="ipt_tdhr header" style="font-weight: bold; text-align: left;">GRAND TOTALS</td>
                                
                                <!-- Location Grand Totals -->
                                <template v-for="location in allLocations">
                                    <td :key="location + '-total-sales'" class="ipt_tdhr header" style="font-weight: bold;">
                                        {{ getGrandTotalForLocation(location).totalInvoices }}
                                    </td>
                                    <td :key="location + '-total-used'" class="ipt_tdhr header" style="font-weight: bold;">
                                        {{ formatNumber(getGrandTotalForLocation(location).usedAmount) }}
                                    </td>
                                    <td :key="location + '-total-approved'" class="ipt_tdhr header" style="font-weight: bold;">
                                        {{ formatNumber(getGrandTotalForLocation(location).approvedAmount) }}
                                    </td>
                                </template>
                                
                                <!-- Overall Grand Totals -->
                                <td class="ipt_tdhr header" style="font-weight: bold;">
                                    {{ getOverallTotals().totalInvoices }}
                                </td>
                                <td class="ipt_tdhr header" style="font-weight: bold;">
                                    {{ formatNumber(getOverallTotals().usedAmount) }}
                                </td>
                                <td class="ipt_tdhr header" style="font-weight: bold;">
                                    {{ formatNumber(getOverallTotals().approvedAmount) }}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div v-else-if="financeData.length === 0 && !loading">
                    <b-alert show variant="warning">No finance records found</b-alert>
                </div>
            </b-overlay>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import Requestor from '@/utilities/Requestor';
import { BIconFunnelFill } from 'bootstrap-vue'

export default {
    name: "FinanceSalesReports",
    components: { DatePicker, BIconFunnelFill },
    data: function(){
        return {
            packet: {},
            financeData: [],
            loading: false,
            date_range: [],
            picked_date_range: null,
            sort_asc: false,
            sort_summary_asc: false,
            sort_summary_key: 'approvedAmount',
            picked_user: null,
            picked_location: null,
            picked_finance_company: null,
            view_type: 'detailed',
            view_type_options: [
                { value: 'detailed', text: 'DETAILED VIEW' },
                { value: 'summary', text: 'SUMMARY VIEW' },
                { value: 'location_summary', text: 'LOCATION SUMMARY' } 
            ],
            showFinanceCompaniesGrid: false,
            companySearch: '',
            autoRefreshEnabled: false,
            autoRefreshInterval: null,

            // Location mapping
            locationMap: {
                16: "HUNTING PARK",
                44: "ONLINE SALES",
                29: "LANCASTER",
                25: "ALLENTOWN",
                27: "READING",
                28: "EWING",
                22: "LANSDOWNE",
                17: "UPPER DARBY",
                46: "OUT OF STOCK",
                40: "9TH ST",
                36: "VENANGO",
                24: "DELMAR",
                47: "MECCA SHIPPING",
                42: "101 WH",
                41: "FOLCROFT"
            },
            filtersVisible: false,
            isMobile: false,
        }
    },
    computed: {
        // Add this computed property
        flattenedLocationHeaders() {
            const headers = [];
            this.allLocations.forEach(location => {
                headers.push({ type: 'sales', location, key: location + '-sales-sub' });
                headers.push({ type: 'used', location, key: location + '-used-sub' });
                headers.push({ type: 'approved', location, key: location + '-approved-sub' });
            });
            return headers;
        },
        locationSummaryData: function() {
            const locationMap = {};
            
            this.filteredFinanceData.forEach(item => {
                const financeCompany = this.getFinanceCompanyName(item);
                const location = this.getLocationName(item.locsub);
                
                if (!financeCompany || financeCompany === 'Unknown Finance Company') return;
                
                const key = `${financeCompany}|${location}`;
                
                if (!locationMap[key]) {
                    locationMap[key] = {
                        financeCompany,
                        location,
                        totalInvoices: 0,
                        approvedAmount: 0,
                        usedAmount: 0,
                        balanceAmount: 0
                    };
                }
                
                locationMap[key].totalInvoices++;
                locationMap[key].approvedAmount += item.finance_approved_amount || item.approved_amount || 0;
                locationMap[key].usedAmount += item.finance_used_amount || this.getUsedAmount(item) || 0;
            });
            
            // Calculate balance and group by finance company
            Object.keys(locationMap).forEach(key => {
                locationMap[key].balanceAmount = locationMap[key].approvedAmount - locationMap[key].usedAmount;
            });
            
            // Group by finance company for final structure
            const companyMap = {};
            Object.values(locationMap).forEach(item => {
                if (!companyMap[item.financeCompany]) {
                    companyMap[item.financeCompany] = {
                        financeCompany: item.financeCompany,
                        locations: {},
                        totals: {
                            totalInvoices: 0,
                            approvedAmount: 0,
                            usedAmount: 0,
                            balanceAmount: 0
                        }
                    };
                }
                
                // Add location data
                companyMap[item.financeCompany].locations[item.location] = {
                    totalInvoices: item.totalInvoices,
                    approvedAmount: item.approvedAmount,
                    usedAmount: item.usedAmount,
                    balanceAmount: item.balanceAmount
                };
                
                // Update totals
                companyMap[item.financeCompany].totals.totalInvoices += item.totalInvoices;
                companyMap[item.financeCompany].totals.approvedAmount += item.approvedAmount;
                companyMap[item.financeCompany].totals.usedAmount += item.usedAmount;
                companyMap[item.financeCompany].totals.balanceAmount += item.balanceAmount;
            });
            
            return Object.values(companyMap);
        },

        // New computed property to get all unique locations dynamically
        allLocations: function() {
            const locations = new Set();
            
            this.filteredFinanceData.forEach(item => {
                const locationName = this.getLocationName(item.locsub);
                if (locationName && locationName !== 'Unknown Location') {
                    locations.add(locationName);
                }
            });
            
            return Array.from(locations).sort();
        },
        filteredFinanceData: function() {
            let that = this;
            return this.financeData.filter(function(d) {
                // Check location filter
                let locationMatch = true;
                if (that.picked_location) {
                    const locationValue = d.locsub;
                    if (!locationValue) {
                        locationMatch = false;
                    } else {
                        const locationId = parseInt(locationValue.split('|')[0]);
                        locationMatch = locationId == that.picked_location;
                    }
                }

                // Check finance company filter
                let financeCompanyMatch = true;
                if (that.picked_finance_company) {
                    const companyName = that.getFinanceCompanyName(d);
                    financeCompanyMatch = companyName === that.picked_finance_company;
                }

                return (
                    ((that.picked_user) ? d.username == that.picked_user : true ) &&
                    locationMatch &&
                    financeCompanyMatch
                )
            });
        },

        // Finance companies with search filter
        filteredFinanceCompanies() {
            if (!this.companySearch) {
                return this.financeCompaniesSummary;
            }
            const searchTerm = this.companySearch.toLowerCase();
            return this.financeCompaniesSummary.filter(company =>
                company.name.toLowerCase().includes(searchTerm)
            );
        },

        // New computed properties for finance cards
        financeCompaniesCount() {
            const companies = new Set();
            this.financeData.forEach(item => {
                const companyName = this.getFinanceCompanyName(item);
                if (companyName && companyName !== 'Unknown Finance Company') {
                    companies.add(companyName);
                }
            });
            return companies.size;
        },

        topFinanceCompanies() {
            const companySummary = this.financeCompaniesSummary;
            return companySummary.slice(0, 3); // Top 3 for preview
        },

        financeCompaniesSummary() {
            const companyMap = {};

            this.filteredFinanceData.forEach(item => {
                const companyName = this.getFinanceCompanyName(item);
                if (!companyMap[companyName]) {
                    companyMap[companyName] = {
                        name: companyName,
                        approvedAmount: 0,
                        usedAmount: 0,
                        balanceAmount: 0,
                        invoiceCount: 0,
                        utilizationRate: 0
                    };
                }

                companyMap[companyName].approvedAmount += item.finance_approved_amount || item.approved_amount || 0;
                companyMap[companyName].usedAmount += item.finance_used_amount || this.getUsedAmount(item) || 0;
                companyMap[companyName].invoiceCount += 1;
            });

            // Calculate derived values
            Object.keys(companyMap).forEach(companyName => {
                const company = companyMap[companyName];
                company.balanceAmount = company.approvedAmount - company.usedAmount;
                company.utilizationRate = company.approvedAmount > 0 ?
                    (company.usedAmount / company.approvedAmount) * 100 : 0;
            });

            return Object.values(companyMap)
                .sort((a, b) => b.approvedAmount - a.approvedAmount);
        },

        summaryData: function() {
            const summaryMap = {};

            this.filteredFinanceData.forEach(item => {
                const location = this.getLocationName(item.locsub);
                const financeCompany = this.getFinanceCompanyName(item);
                const salesperson = item.username || 'Unknown';

                const key = `${location}|${financeCompany}|${salesperson}`;

                if (!summaryMap[key]) {
                    summaryMap[key] = {
                        location,
                        salesperson,
                        financeCompany,
                        totalInvoices: 0,
                        approvedAmount: 0,
                        usedAmount: 0,
                        balanceAmount: 0,
                        totalSales: 0,
                        averageApproved: 0,
                        utilizationRate: 0
                    };
                }

                summaryMap[key].totalInvoices++;
                summaryMap[key].approvedAmount += item.finance_approved_amount || item.approved_amount || 0;
                summaryMap[key].usedAmount += item.finance_used_amount || this.getUsedAmount(item) || 0;
                summaryMap[key].totalSales += item.total_dollar_amount || 0;
            });

            // Calculate derived values
            Object.keys(summaryMap).forEach(key => {
                const summary = summaryMap[key];
                summary.balanceAmount = summary.approvedAmount - summary.usedAmount;
                summary.averageApproved = summary.totalInvoices > 0 ?
                    summary.approvedAmount / summary.totalInvoices : 0;
                summary.utilizationRate = summary.approvedAmount > 0 ?
                    (summary.usedAmount / summary.approvedAmount) * 100 : 0;
            });

            return Object.values(summaryMap);
        },

        sortedSummaryData: function() {
            let sorted = [...this.summaryData];

            if (this.sort_summary_asc) {
                sorted.sort((a, b) => {
                    if (a[this.sort_summary_key] < b[this.sort_summary_key]) return -1;
                    if (a[this.sort_summary_key] > b[this.sort_summary_key]) return 1;
                    return 0;
                });
            } else {
                sorted.sort((a, b) => {
                    if (a[this.sort_summary_key] > b[this.sort_summary_key]) return -1;
                    if (a[this.sort_summary_key] < b[this.sort_summary_key]) return 1;
                    return 0;
                });
            }

            return sorted;
        },

        summaryTotals: function() {
            const totals = {
                totalInvoices: 0,
                approvedAmount: 0,
                usedAmount: 0,
                balanceAmount: 0,
                totalSales: 0,
                averageApproved: 0,
                utilizationRate: 0
            };

            this.summaryData.forEach(summary => {
                totals.totalInvoices += summary.totalInvoices;
                totals.approvedAmount += summary.approvedAmount;
                totals.usedAmount += summary.usedAmount;
                totals.balanceAmount += summary.balanceAmount;
                totals.totalSales += summary.totalSales;
            });

            totals.averageApproved = totals.totalInvoices > 0 ?
                totals.approvedAmount / totals.totalInvoices : 0;
            totals.utilizationRate = totals.approvedAmount > 0 ?
                (totals.usedAmount / totals.approvedAmount) * 100 : 0;

            return totals;
        },

        available_locations: function() {
            let locationsWithFinance = new Set();

            this.financeData.forEach(item => {
                const locationValue = item.locsub;
                if (locationValue) {
                    const locationId = parseInt(locationValue.split('|')[0]);
                    locationsWithFinance.add(locationId);
                }
            });

            let filteredLocations = this.packet.locations.filter(location =>
                locationsWithFinance.has(location.value)
            );

            return [
                { value: null, text: "ALL" },
                ...filteredLocations
            ];
        },

        available_salespeople: function() {
            if (!this.picked_location) {
                let usersWithFinance = new Set();
                this.financeData.forEach(item => {
                    if (item.username) {
                        usersWithFinance.add(item.username);
                    }
                });

                return [
                    { value: null, text: "ALL" },
                    ...Array.from(usersWithFinance).map(user => ({ value: user, text: user }))
                ];
            } else {
                let usersInLocation = new Set();
                this.financeData.forEach(item => {
                    const locationValue = item.locsub;
                    if (locationValue) {
                        const locationId = parseInt(locationValue.split('|')[0]);
                        if (locationId === this.picked_location && item.username) {
                            usersInLocation.add(item.username);
                        }
                    }
                });

                return [
                    { value: null, text: "ALL" },
                    ...Array.from(usersInLocation).map(user => ({ value: user, text: user }))
                ];
            }
        },

        finance_company_options: function() {
            let financeCompanies = new Set();

            this.financeData.forEach(item => {
                const companyName = this.getFinanceCompanyName(item);
                if (companyName && companyName !== 'Unknown Finance Company') {
                    financeCompanies.add(companyName);
                }
            });

            return [
                { value: null, text: "ALL FINANCE COMPANIES" },
                ...Array.from(financeCompanies).sort().map(company => ({
                    value: company,
                    text: company
                }))
            ];
        }
    },
    methods: {
        getLocationData(company, locationName) {
            return company.locations[locationName] || { totalInvoices: 0, approvedAmount: 0, usedAmount: 0, balanceAmount: 0 };
        },
        getOtherLocationsData(company) {
            const mainLocations = ['LANCASTER', 'ALLENTOWN', 'UPPER DARBY'];
            let otherData = { totalInvoices: 0, approvedAmount: 0, usedAmount: 0, balanceAmount: 0 };
            
            Object.keys(company.locations).forEach(location => {
                if (!mainLocations.includes(location)) {
                    otherData.totalInvoices += company.locations[location].totalInvoices;
                    otherData.approvedAmount += company.locations[location].approvedAmount;
                    otherData.usedAmount += company.locations[location].usedAmount;
                    otherData.balanceAmount += company.locations[location].balanceAmount;
                }
            });
            
            return otherData;
        },
        getGrandTotalForLocation(locationName) {
            let totals = { totalInvoices: 0, approvedAmount: 0, usedAmount: 0 };
            
            this.locationSummaryData.forEach(company => {
                const locationData = this.getLocationData(company, locationName);
                totals.totalInvoices += locationData.totalInvoices;
                totals.approvedAmount += locationData.approvedAmount;
                totals.usedAmount += locationData.usedAmount;
            });
            
            return totals;
        },

        // Helper method to get grand totals for other locations
        getGrandTotalOtherLocations() {
            let totals = { totalInvoices: 0, approvedAmount: 0, usedAmount: 0 };
            
            this.locationSummaryData.forEach(company => {
                const otherData = this.getOtherLocationsData(company);
                totals.totalInvoices += otherData.totalInvoices;
                totals.approvedAmount += otherData.approvedAmount;
                totals.usedAmount += otherData.usedAmount;
            });
            
            return totals;
        },

        // Helper method to get overall totals
        getOverallTotals() {
            let totals = { totalInvoices: 0, approvedAmount: 0, usedAmount: 0 };
            
            this.locationSummaryData.forEach(company => {
                totals.totalInvoices += company.totals.totalInvoices;
                totals.approvedAmount += company.totals.approvedAmount;
                totals.usedAmount += company.totals.usedAmount;
            });
            
            return totals;
        },
        handleResize() {
            this.isMobile = window.innerWidth < 768;
        },
        // New methods for finance companies grid
        toggleFinanceCompaniesGrid() {
            this.showFinanceCompaniesGrid = !this.showFinanceCompaniesGrid;
        },

        getCompanyStatusClass(utilizationRate) {
            if (utilizationRate >= 80) return 'status-high';
            if (utilizationRate >= 50) return 'status-medium';
            return 'status-low';
        },

        getCompanyStatus(utilizationRate) {
            if (utilizationRate >= 80) return 'High Usage';
            if (utilizationRate >= 50) return 'Medium Usage';
            return 'Low Usage';
        },

        getProgressColorClass(utilizationRate) {
            if (utilizationRate >= 80) return 'progress-high';
            if (utilizationRate >= 50) return 'progress-medium';
            return 'progress-low';
        },

        getEfficiencyClass(utilizationRate) {
            if (utilizationRate >= 70) return 'efficiency-high';
            if (utilizationRate >= 40) return 'efficiency-medium';
            return 'efficiency-low';
        },

        getEfficiencyRating(utilizationRate) {
            if (utilizationRate >= 70) return 'Excellent';
            if (utilizationRate >= 40) return 'Good';
            return 'Low';
        },

        // Existing methods
        showFinanceDetails(type) {
            console.log('Showing finance details for:', type);
        },

        filterByFinanceCompany(companyName) {
            this.picked_finance_company = companyName;
            this.processFinanceData();

            this.$bvToast.toast(`Filtered by ${companyName}`, {
                variant: 'info',
                autoHideDelay: 2000
            });
        },

        getCompanyInitials(companyName) {
            return companyName
                .split(' ')
                .map(word => word.charAt(0))
                .join('')
                .toUpperCase()
                .substring(0, 2);
        },

        getUtilizationPercentage() {
            return this.summaryTotals.approvedAmount > 0 ?
                Math.round((this.summaryTotals.usedAmount / this.summaryTotals.approvedAmount) * 100) : 0;
        },

        getBalancePercentage() {
            const maxAmount = Math.max(this.summaryTotals.approvedAmount, this.summaryTotals.usedAmount);
            return maxAmount > 0 ? Math.round((this.summaryTotals.balanceAmount / maxAmount) * 100) : 0;
        },

        getBalanceClass(balance) {
            return balance < 0 ? 'negative-balance' : 'positive-balance';
        },

        formatNumber(num) {
            if (num === undefined || num === null || isNaN(num)) {
                return '0.00';
            }
            return num.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatCompactNumber(num) {
            if (num === undefined || num === null || isNaN(num)) {
                return '0';
            }
            if (num >= 1000000) {
                return (num / 1000000).toFixed(1) + 'M';
            } else if (num >= 1000) {
                return (num / 1000).toFixed(1) + 'K';
            }
            return num.toFixed(0);
        },

        exportAllFinanceData() {
            const dataToExport = this.filteredFinanceData.map(item => ({
                'Date': this.formatDate(item.ts),
                'Location': this.getLocationName(item.locsub),
                'Finance Company': this.getFinanceCompanyName(item),
                'Sales Person': item.username,
                'Invoice #': item.invoice_id,
                'Approved Amount': item.finance_approved_amount || item.approved_amount || 0,
                'Used Amount': item.finance_used_amount || this.getUsedAmount(item) || 0,
                'Balance Amount': (item.finance_approved_amount || item.approved_amount || 0) - (item.finance_used_amount || this.getUsedAmount(item) || 0),
                'Total Sold': item.total_dollar_amount || 0,
                'Difference': (item.total_dollar_amount - item.total_actualized_dollar_amount) || 0
            }));

            this.exportToCSV(dataToExport, 'finance-data-export');
        },

        exportSummaryData() {
            const dataToExport = this.sortedSummaryData.map(summary => ({
                'Location': summary.location,
                'Salesperson': summary.salesperson,
                'Finance Company': summary.financeCompany,
                'Total Invoices': summary.totalInvoices,
                'Approved Amount': summary.approvedAmount,
                'Used Amount': summary.usedAmount,
                'Balance Amount': summary.balanceAmount,
                'Total Sales': summary.totalSales,
                'Average Approved': summary.averageApproved,
                'Utilization Rate': summary.utilizationRate.toFixed(1) + '%'
            }));

            this.exportToCSV(dataToExport, 'finance-summary');
        },

        exportToCSV(data, filename) {
            if (data.length === 0) {
                this.$bvToast.toast('No data to export', { variant: 'warning' });
                return;
            }

            const headers = Object.keys(data[0]).join(',');
            const csv = [headers, ...data.map(row =>
                Object.values(row).map(value =>
                    typeof value === 'string' ? `"${value}"` : value
                ).join(',')
            )].join('\n');

            const blob = new Blob([csv], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${filename}-${new Date().toISOString().split('T')[0]}.csv`;
            a.click();
            window.URL.revokeObjectURL(url);

            this.$bvToast.toast('Data exported successfully', { variant: 'success' });
        },

        toggleAutoRefresh() {
            if (this.autoRefreshEnabled) {
                this.startAutoRefresh();
            } else {
                this.stopAutoRefresh();
            }
        },

        startAutoRefresh() {
            this.autoRefreshInterval = setInterval(() => {
                this.fetchFinanceData();
            }, 30000);
        },

        stopAutoRefresh() {
            if (this.autoRefreshInterval) {
                clearInterval(this.autoRefreshInterval);
                this.autoRefreshInterval = null;
            }
        },

        // Your existing data methods
        getFinanceRowStyle(item) {
            if (item.is_refund_entry) {
                return { background: '#ffab91' };
            }
            const balance = item.finance_balance_amount || this.getBalanceAmount(item);
            if (balance < 0) {
                return { background: '#ffcccc' };
            }
            return { background: 'white' };
        },

        getSummaryRowStyle(summary) {
            if (summary.balanceAmount < 0) {
                return { background: '#fff0f0' };
            }
            return { background: 'white' };
        },

        getBalanceStyle(item) {
            const balance = item.finance_balance_amount || this.getBalanceAmount(item);
            if (balance < 0) {
                return { color: '#dc3545', fontWeight: 'bold' };
            }
            return { color: '#28a745', fontWeight: 'bold' };
        },

        getSummaryBalanceStyle(balance) {
            if (balance < 0) {
                return { color: '#dc3545', fontWeight: 'bold' };
            }
            return { color: '#28a745', fontWeight: 'bold' };
        },

        getUtilizationStyle(rate) {
            if (rate > 80) {
                return { color: '#28a745', fontWeight: 'bold' };
            } else if (rate > 50) {
                return { color: '#ffc107', fontWeight: 'bold' };
            } else {
                return { color: '#dc3545', fontWeight: 'bold' };
            }
        },

        formatDate(dateString) {
            return moment(dateString, 'MM-DD-YYYY HH:mm:ss A').format('MM/DD/YYYY');
        },

        getLocationName(locsub) {
            if (!locsub) return 'Unknown Location';
            const locationId = parseInt(locsub.split('|')[0]);
            return this.locationMap[locationId] || `Location ${locationId}`;
        },

        getFinanceCompanyName(item) {
            // If we split into separate entries, use the stored payment_method
            if (item.payment_method) {
                const parts = item.payment_method.split(' - ');
                return parts.length > 1 ? parts[1] : item.payment_method;
            }
            
            // Fallback to original logic with payment_methods_with_amounts
            if (item.payment_methods_with_amounts && Array.isArray(item.payment_methods_with_amounts)) {
                const financeMethod = item.payment_methods_with_amounts.find(pm =>
                    pm.method && pm.method.includes('FINANCE')
                );
                if (financeMethod) {
                    const parts = financeMethod.method.split(' - ');
                    return parts.length > 1 ? parts[1] : financeMethod.method;
                }
            }
            return 'Unknown Finance Company';
        },

        getFinanceAmount(item) {
            if (!item.payment_methods_with_amounts || !Array.isArray(item.payment_methods_with_amounts)) {
                return 0;
            }
            
            // Sum up only the FINANCE payment amounts
            return item.payment_methods_with_amounts
                .filter(pm => pm.method && pm.method.includes('FINANCE'))
                .reduce((sum, pm) => sum + (pm.amount || 0), 0);
        },

        getFinanceApprovedAmount(item) {
            if (!item.payment_methods_with_amounts || !Array.isArray(item.payment_methods_with_amounts)) {
                return 0;
            }
            
            // Sum up only the FINANCE approved amounts
            return item.payment_methods_with_amounts
                .filter(pm => pm.method && pm.method.includes('FINANCE'))
                .reduce((sum, pm) => sum + (pm.approved_amount || 0), 0);
        },

        getUsedAmount(item) {
            // If we have finance-specific used amount, use it
            if (item.finance_used_amount !== undefined) {
                return item.finance_used_amount;
            }
            // Otherwise use the finance amount from payment methods
            return this.getFinanceAmount(item);
        },

        getBalanceAmount(item) {
            const approved = item.finance_approved_amount || item.approved_amount || 0;
            const used = item.finance_used_amount || this.getUsedAmount(item) || 0;
            return approved - used;
        },

        total(key) {
            let total_val = 0.0;
            for (var i = 0; i < this.filteredFinanceData.length; i++) {
                const item = this.filteredFinanceData[i];
                if (key === 'used_amount') {
                    total_val += item.finance_used_amount || this.getUsedAmount(item) || 0;
                } else if (key === 'balance_amount') {
                    total_val += item.finance_balance_amount || this.getBalanceAmount(item) || 0;
                } else if (key === 'approved_amount') {
                    total_val += item.finance_approved_amount || item.approved_amount || 0;
                } else {
                    total_val += (parseFloat(item[key]) || 0.0);
                }
            }
            return total_val;
        },

        locationChanged() {
            this.picked_user = null;
            this.processFinanceData();
        },

        set_dates(value) {
            let start = null;
            let end = null;

            if(value == 'today') {
                start = moment().format("MM-DD-YYYY");
                end = moment().format("MM-DD-YYYY");
            }
            if(value == 'yesterday') {
                start = moment().add(-1, 'days').format("MM-DD-YYYY");
                end = moment().add(-1, 'days').format("MM-DD-YYYY");
            }
            if(value == 'this_week') {
                start = moment().startOf('week').format("MM-DD-YYYY");
                end = moment().endOf('week').format("MM-DD-YYYY");
            }
            if(value == 'last_week') {
                start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY");
                end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY");
            }
            if(value == 'this_month') {
                start = moment().startOf('month').format("MM-DD-YYYY");
                end = moment().endOf('month').format("MM-DD-YYYY");
            }
            if(value == 'last_month') {
                start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY");
                end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY");
            }

            if (start && end) {
                this.date_range = [start, end];
                this.picked_date_range = value;
                this.fetchFinanceData();
            }
        },

        async fetchFinanceData() {
            this.loading = true;
            try {
                const data = {
                    dates: this.date_range,
                    username: this.packet.userDetails.username,
                    user_id: this.packet.userDetails.id,
                    location_id: this.picked_location
                };

                const response = await new Promise((resolve, reject) => {
                    Requestor.postSyncP("/api/reports/reports_v3/", data, this,
                        (response) => resolve(response),
                        (error) => reject(error)
                    );
                });

                if (response.data && response.data.result) {
                    // Create separate entries for each finance payment method
                    const financeEntries = [];
                    
                    response.data.result.forEach(item => {
                        if (item.payment_methods_with_amounts && Array.isArray(item.payment_methods_with_amounts)) {
                            // Find all FINANCE payment methods
                            const financePayments = item.payment_methods_with_amounts.filter(pm => 
                                pm.method && pm.method.includes('FINANCE')
                            );
                            
                            // Create a separate entry for each FINANCE payment
                            financePayments.forEach((payment, index) => {
                                financeEntries.push({
                                    ...item,
                                    // Override with finance-specific values
                                    payment_method: payment.method,
                                    finance_amount: payment.amount,
                                    finance_approved_amount: payment.approved_amount || 0,
                                    finance_used_amount: payment.amount, // Assuming used amount equals the payment amount
                                    finance_balance_amount: (payment.approved_amount || 0) - payment.amount,
                                    // Create a unique identifier
                                    unique_id: `${item.invoice_id}_FINANCE_${index}`,
                                    // Track original item reference if needed
                                    original_invoice: item.invoice_id
                                });
                            });
                        }
                    });
                    
                    this.financeData = financeEntries;
                    this.processFinanceData();

                    // Reset filters when new data is loaded
                    this.picked_location = null;
                    this.picked_user = null;
                    this.picked_finance_company = null;
                } else {
                    this.financeData = [];
                }
            } catch (error) {
                console.error('Error fetching finance data:', error);
                this.financeData = [];
                this.$bvToast.toast(
                    "Error occurred. Please try again.",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
            } finally {
                this.loading = false;
            }
        },

        processFinanceData() {
            // Additional processing if needed
        },

        sortby(key) {
            if (this.sort_asc) {
                this.financeData = Requestor.sort(this.financeData, key);
            } else {
                this.financeData = Requestor.sort_reverse(this.financeData, key);
            }
            this.sort_asc = !this.sort_asc;
        },

        sortSummary(key) {
            this.sort_summary_key = key;
            this.sort_summary_asc = !this.sort_summary_asc;
        }
    },
    mounted: function() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    created: function() {
        this.packet = JSON.parse(localStorage.packet);
        this.packet.userDetails = JSON.parse(localStorage.userDetails);
    },

    beforeDestroy() {
        this.stopAutoRefresh();
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style scoped>
    .header {
        font-size: 12px;
    }
    .non-header {
        font-weight: normal;
        font-size: 11px;
    }

    .ipt_tdhr {
        padding: 4px 8px;
        border: 1px solid #dee2e6;
        text-align: left;
    }

    /* KPI Summary Row */
    .finance-kpi-row {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 15px;
        margin-bottom: 25px;
        padding: 0 10px;
    }

    .kpi-item {
        background: rgba(255, 255, 255, 0.9);
        border-radius: 12px;
        padding: 20px;
        text-align: center;
        border: 1px solid rgba(226, 232, 240, 0.8);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
    }

    .kpi-item:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    }

    .kpi-value {
        font-size: 1.8rem;
        font-weight: 800;
        color: #2d3748;
        margin-bottom: 8px;
        line-height: 1;
    }

    .kpi-label {
        font-size: 0.9rem;
        color: #718096;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    /* Finance Companies Cards Section */
    .finance-companies-cards-section {
        margin: 30px 0;
        padding: 20px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 12px;
        border: 1px solid rgba(226, 232, 240, 0.8);
    }

    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 25px;
        padding-bottom: 15px;
        border-bottom: 2px solid rgba(66, 153, 225, 0.1);
    }

    .section-title {
        color: #2d3748;
        font-weight: 700;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .section-title i {
        color: #00698B;
        font-size: 1.2em;
    }

    .section-actions {
        display: flex;
        gap: 15px;
        align-items: center;
    }

    .finance-companies-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
        gap: 20px;
        margin-bottom: 20px;
    }

    .finance-company-full-card {
        background: rgba(255, 255, 255, 0.95);
        border-radius: 12px;
        border: 1px solid rgba(226, 232, 240, 0.8);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        overflow: hidden;
        position: relative;
    }

    .finance-company-full-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        border-color: rgba(66, 153, 225, 0.5);
    }

    .company-full-card-header {
        display: flex;
        align-items: center;
        padding: 20px;
        background: linear-gradient(135deg, rgba(66, 153, 225, 0.05), rgba(66, 153, 225, 0.02));
        border-bottom: 1px solid rgba(226, 232, 240, 0.6);
        gap: 15px;
    }

    .company-avatar-large {
        width: 60px;
        height: 60px;
        border-radius: 12px;
        background: linear-gradient(135deg, #00698B, #004d63);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: 800;
        font-size: 1.2rem;
        flex-shrink: 0;
    }

    .company-main-info {
        flex: 1;
        min-width: 0;
    }

    .company-full-name {
        color: #2d3748;
        font-weight: 700;
        margin: 0 0 8px 0;
        font-size: 1.1rem;
        word-break: break-word;
    }

    .company-meta {
        display: flex;
        gap: 15px;
        flex-wrap: wrap;
    }

    .meta-item {
        font-size: 0.85rem;
        color: #718096;
        display: flex;
        align-items: center;
        gap: 5px;
        font-weight: 600;
    }

    .meta-item i {
        color: #00698B;
        font-size: 0.8rem;
    }

    .company-status {
        padding: 6px 12px;
        border-radius: 20px;
        font-size: 0.75rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        flex-shrink: 0;
    }

    .status-high {
        background: rgba(220, 53, 69, 0.1);
        color: #dc3545;
        border: 1px solid rgba(220, 53, 69, 0.2);
    }

    .status-medium {
        background: rgba(255, 193, 7, 0.1);
        color: #ffc107;
        border: 1px solid rgba(255, 193, 7, 0.2);
    }

    .status-low {
        background: rgba(40, 167, 69, 0.1);
        color: #28a745;
        border: 1px solid rgba(40, 167, 69, 0.2);
    }

    .company-full-card-body {
        padding: 20px;
    }

    .company-stats-grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 15px;
        margin-bottom: 20px;
    }

    .company-stat {
        text-align: center;
        padding: 15px;
        background: rgba(255, 255, 255, 0.7);
        border-radius: 8px;
        border: 1px solid rgba(226, 232, 240, 0.6);
    }

    .stat-label {
        font-size: 0.8rem;
        color: #718096;
        font-weight: 600;
        margin-bottom: 8px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .stat-value {
        font-size: 1.1rem;
        font-weight: 800;
        color: #2d3748;
        margin-bottom: 6px;
        line-height: 1;
    }

    .stat-trend {
        font-size: 0.75rem;
        color: #718096;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        font-weight: 600;
    }

    .company-progress-section {
        margin-bottom: 20px;
    }

    .progress-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        font-size: 0.9rem;
        font-weight: 600;
        color: #2d3748;
    }

    .progress-bar-full {
        width: 100%;
    }

    .progress-track {
        width: 100%;
        height: 10px;
        background: rgba(108, 117, 125, 0.1);
        border-radius: 5px;
        overflow: hidden;
        margin-bottom: 5px;
    }

    .progress-fill {
        height: 100%;
        border-radius: 5px;
        transition: width 0.3s ease;
    }

    .progress-high {
        background: linear-gradient(135deg, #dc3545, #c82333);
    }

    .progress-medium {
        background: linear-gradient(135deg, #ffc107, #fd7e14);
    }

    .progress-low {
        background: linear-gradient(135deg, #28a745, #20c997);
    }

    .progress-labels {
        display: flex;
        justify-content: space-between;
        font-size: 0.7rem;
        color: #718096;
        font-weight: 600;
    }

    .company-performance {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
    }

    .performance-item {
        text-align: center;
        padding: 12px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 8px;
        border: 1px solid rgba(226, 232, 240, 0.5);
    }

    .performance-label {
        font-size: 0.75rem;
        color: #718096;
        font-weight: 600;
        margin-bottom: 5px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .performance-value {
        font-size: 0.9rem;
        font-weight: 700;
        color: #2d3748;
    }

    .efficiency-high {
        color: #28a745;
    }

    .efficiency-medium {
        color: #ffc107;
    }

    .efficiency-low {
        color: #dc3545;
    }

    .company-full-card-footer {
        padding: 15px 20px;
        background: rgba(66, 153, 225, 0.05);
        border-top: 1px solid rgba(226, 232, 240, 0.6);
    }

    .click-hint {
        font-size: 0.8rem;
        color: #718096;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-weight: 600;
    }

    .click-hint i {
        color: #00698B;
    }

    .show-companies-section {
        text-align: center;
        margin: 30px 0;
        padding: 20px;
    }

    .show-companies-btn {
        padding: 12px 30px;
        font-weight: 600;
        border-radius: 8px;
    }

    .no-companies-found {
        text-align: center;
        padding: 60px 20px;
        color: #718096;
    }

    .no-companies-found i {
        font-size: 3rem;
        margin-bottom: 15px;
        color: #cbd5e0;
    }

    .no-companies-found h5 {
        color: #718096;
        margin-bottom: 10px;
    }

    /* Responsive Design for Finance Companies Grid */
    @media (max-width: 1200px) {
        .finance-companies-grid {
            grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        }
    }

    @media (max-width: 768px) {
        .finance-companies-grid {
            grid-template-columns: 1fr;
        }

        .section-header {
            flex-direction: column;
            gap: 15px;
            align-items: flex-start;
        }

        .section-actions {
            width: 100%;
            justify-content: space-between;
        }

        .company-stats-grid {
            grid-template-columns: 1fr;
            gap: 10px;
        }

        .company-full-card-header {
            flex-direction: column;
            text-align: center;
            gap: 12px;
        }

        .company-meta {
            justify-content: center;
        }
    }

    @media (max-width: 480px) {
        .finance-companies-cards-section {
            padding: 15px;
            margin: 20px 0;
        }

        .company-full-card-header {
            padding: 15px;
        }

        .company-full-card-body {
            padding: 15px;
        }

        .company-avatar-large {
            width: 50px;
            height: 50px;
            font-size: 1rem;
        }

        .company-full-name {
            font-size: 1rem;
        }
    }

    /* Responsive Design */
    @media (max-width: 768px) {
        .finance-kpi-row {
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
            gap: 10px;
        }

        .kpi-item {
            padding: 15px;
        }

        .kpi-value {
            font-size: 1.5rem;
        }

        .header-stats-grid {
            grid-template-columns: 1fr;
            gap: 15px;
        }

        .stat-item {
            padding: 12px;
        }

        .stat-item .stat-value {
            font-size: 1.3rem;
        }

        .stat-item .stat-icon {
            width: 45px;
            height: 45px;
            font-size: 1.3rem;
        }
    }

    @media (max-width: 480px) {
        .finance-kpi-row {
            grid-template-columns: 1fr 1fr;
        }
    }

    /* Animation for card interactions */
    @keyframes cardPulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.05); }
        100% { transform: scale(1); }
    }

    .finance-summary-card:active {
        animation: cardPulse 0.3s ease;
    }

    /* Loading state for cards */
    .finance-summary-card.loading {
        opacity: 0.7;
        pointer-events: none;
    }

    .finance-summary-card.loading::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
        animation: loading 1.5s infinite;
    }

    @keyframes loading {
        0% { left: -100%; }
        100% { left: 100%; }
    }

    /* Empty state styling */
    .finance-cards-empty {
        text-align: center;
        padding: 40px 20px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 12px;
        border: 2px dashed rgba(226, 232, 240, 0.8);
        margin: 20px 0;
    }

    .finance-cards-empty i {
        font-size: 3rem;
        color: #cbd5e0;
        margin-bottom: 15px;
    }

    .finance-cards-empty h5 {
        color: #718096;
        margin-bottom: 10px;
    }

    /* High DPI Screen Optimization */
    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
        .finance-summary-card,
        .finance-company-full-card {
            backdrop-filter: blur(10px);
        }
    }

    /* Reduced Motion Support */
    @media (prefers-reduced-motion: reduce) {
        .finance-summary-card,
        .finance-company-full-card,
        .clickable-card {
            transition: none;
        }

        .clickable-card::after {
            display: none;
        }
    }
    .ipt_tdhr {
    padding: 8px 12px; /* Increased padding */
    border: 1px solid #dee2e6;
    text-align: left;
    font-size: 14px; /* Larger font size */
}

.header {
    font-size: 15px !important; /* Larger header font */
    font-weight: bold;
}

.non-header {
    font-weight: normal;
    font-size: 14px !important; /* Larger body font */
}

/* Make the entire table larger */
table.text-monospace {
    font-size: 14px; /* Base table font size */
    line-height: 1.5; /* Better readability */
}
.sub-header {
    font-size: 11px !important;
    font-weight: 600;
    text-align: center;
}

/* Ensure table cells have proper alignment */
.ipt_tdhr {
    padding: 8px 12px;
    border: 1px solid #dee2e6;
    text-align: center;
    font-size: 14px;
}

/* Make finance company names left-aligned */
.ipt_tdhr:first-child {
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Reports/FinanceSalesReports.vue